// Global
import { classnames, TTailwindString } from 'tailwindcss-classnames';

export type ThemeOptions =
  | 'theme-white'
  | 'theme-whisper'
  | 'theme-blue'
  | 'theme-navy-blue'
  | 'theme-white-black'
  | 'theme-whisper-black'
  | 'theme-inherit'
  | 'theme-white-nrc'
  | 'theme-night';

export const ThemeOptionsDefault: ThemeOptions = 'theme-white';

const bgThemeBg = `bg-theme-bg`;
const textThemeText = `text-theme-text`;

const themes: Record<ThemeOptions, TTailwindString> = {
  'theme-white': classnames('theme-white', bgThemeBg, textThemeText),
  'theme-whisper': classnames('theme-whisper', bgThemeBg, textThemeText),
  'theme-blue': classnames('theme-blue', bgThemeBg, textThemeText),
  'theme-navy-blue': classnames('theme-navy-blue', bgThemeBg, textThemeText),
  'theme-white-black': classnames('theme-white-black', bgThemeBg, textThemeText),
  'theme-whisper-black': classnames('theme-whisper-black', bgThemeBg, textThemeText),
  'theme-inherit': classnames(),
  'theme-white-nrc': classnames(),
  'theme-night': classnames('theme-night'),
};

/**
 * Return relevant classes for the selected theme, or return null
 * if no additional theme classes need to be applied
 * @param {ThemeOptions | 'inherit' | undefined} theme The theme option to get classes for
 * @returns {TTailwindString | null} The relevant tailwind-classnames TArg
 */
const getThemeClasses = (theme: ThemeOptions | undefined): TTailwindString | null => {
  return typeof theme === 'undefined' ? null : themes[theme];
};

export default getThemeClasses;
